<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Accredited Course Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel
              :data="selected"
              :fields="export_fields"
              name="accreditedCourseReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="accreditedCourseReports"
          :loading="loading"
          :options.sync="options"
          :server-items-length="accreditedCourseReports.count"
          class="elevation-1"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="accreditorValue"
                  hide-details
                  label="Accreditor Name"
                  single-line
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="accreditationCodeValue"
                  label="Accreditation Code"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="courseNameValue"
                  label="Course Name"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="courseCodeValue"
                  label="Course Code"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-menu
                  ref="menu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="accrDateFromValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Accreditation Date From"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="date"
                    v-model="accrDateFromValue"
                    no-title
                    placeholder="Accreditation Date From"
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-menu
                  ref="menu"
                  v-model="startMenu2"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="accrDateToValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Accreditation Date To"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="date"
                    v-model="accrDateToValue"
                    no-title
                    placeholder="Accreditation Date To"
                    scrollable
                    @input="startMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:[`item.accreditorName`]="{ item }">
          <label for="item">{{
              item.accreditorName ? item.accreditorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.course`]="{ item }">
          <label for="item">{{
              item.course ? (item.course.continualEducationUnit ? item.course.continualEducationUnit : "-") : "-"
            }}</label>
        </template>
        <template v-slot:[`item.courseName`]="{ item }">
          <label for="item">{{
              item.courseName ? item.courseName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.course.courseDuration`]="{ item }">
          <label for="item">{{
              item.course.courseDuration ? item.course.courseDuration + " Day" : "-"
            }}</label>
        </template>
        <template v-slot:[`item.courseAccreditationDate`]="{ item }">
          <label for="item">{{
              item.courseAccreditationDate ? item.courseAccreditationDate : "-"
            }}</label>
        </template>
        <template v-slot:[`item.courseOwner`]="{ item }">
          <label for="item">{{
              item.courseOwner ? item.courseOwner.trainingCenterName : "-"
            }}</label>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {AccreditedCourseService} from "./accredited-course-service";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  data() {
    return {
      accreditedCourseReports: [],
      headers: [
        {
          text: "Course Name",
          value: "courseName"
        },
        {
          text: "Course Code",
          value: "courseCode"
        },
        {
          text: "Course Duration",
          value: "course.courseDuration"
        },
        {
          text: "CEU",
          value: "course.continualEducationUnit"
        },
        {text: "Course Owner", value: "courseOwner.trainingCenterName"},
        {
          text: "Course Accreditation Date",
          value: "courseAccreditationDate"
        },
        {
          text: "Accreditor's Name",
          value: "accreditorName"
        },
        {
          text: "Accreditation Code",
          value: "accreditationCode"
        },

      ],
      selected: [],
      export_fields: {
        "Course Name": "courseName",
        "Course Duration": "course.courseDuration",
        "CEU": "course.continualEducationUnit",
        "Course Owner": "courseOwner.trainingCenterName",
        "Course Accreditation Date": "courseAccreditationDate",
        "Accreditor's Name": "accreditorName",
        "Accreditation Code": "accreditationCode",
        "Accreditor's Status": {
          field: "accreditorStatus",
          callback: (value) => {
            const resp = value !== null ? (value ? 'Active' : 'Not Active') : '-';
            return resp;
          }
        },

      },
      accreditorValue: null,
      accreditationCodeValue: null,
      courseNameValue: null,
      courseCodeValue: null,
      startMenu: false,
      startMenu2: false,
      accrDateFromValue: null,
      accrDateToValue: null,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,
      options: {
        page: 1,
        itemsPerPage: 10
      }
    };
  },
  async beforeMount() {
    this.fetchAccreditedCReports();
  },
  watch: {
    options: {
      handler() {
        this.fetchAccreditedCReports();
      },
      deep: true
    },
    accreditorValue: function (val) {
      this.accreditorValue = val == '' ? null : val;
      this.fetchAccreditedCReports();
    },
    accreditationCodeValue: function (val) {
      this.accreditationCodeValue = val == '' ? null : val;
      this.fetchAccreditedCReports();
    },
    courseNameValue: function (val) {
      this.courseNameValue = val == '' ? null : val;
      this.fetchAccreditedCReports();
    },
    courseCodeValue: function (val) {
      this.courseCodeValue = val == '' ? null : val;
      this.fetchAccreditedCReports();
    },
    accrDateFromValue: function (val) {
      this.accrDateFromValue = val == '' ? null : val;
      this.fetchAccreditedCReports();
    },
    accrDateToValue: function (val) {
      this.accrDateToValue = val == '' ? null : val;
      this.fetchAccreditedCReports();
    },
    dateRangePreset: function (val) {
      this.applyPresetWithSelection(val, "accrDateFromValue", "accrDateToValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "accrDateFromValue", "accrDateToValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "accrDateFromValue", "accrDateToValue", "dateRangeYear", "dateRangePeriod");
      }
    }
  },
  methods: {
    async fetchAccreditedCReports() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.accreditorValue !== null && (searchParams += '&accreditorName=' + this.accreditorValue);
      this.accreditationCodeValue !== null && (searchParams += '&accreditationCode=' + this.accreditationCodeValue);
      this.courseNameValue !== null && (searchParams += '&courseName=' + this.courseNameValue);
      this.courseCodeValue !== null && (searchParams += '&courseCode=' + this.courseCodeValue);
      this.accrDateFromValue !== null && (searchParams += '&accreditationDateStartDate=' + this.accrDateFromValue);
      this.accrDateToValue !== null && (searchParams += '&accreditationDateEndDate=' + this.accrDateToValue);

      const res = await AccreditedCourseService.getAccreditedCourseWP(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.accreditedCourseReports = res.data.rows;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching accredited course reports, Please try Again!"
        );
      }
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
  },
};
</script>
